import CityPageTemplate from "@/components/site/CityPageTemplate";

export default function FinanzberatungLudwigshafen() {
  return (
    <CityPageTemplate
      city="Ludwigshafen"
      slug="ludwigshafen"
      intro="Ludwigshafen als Chemiestadt am Rhein – wir mischen die richtigen Zutaten für Deinen Vermögensaufbau."
      description="Unabhängige & digitale Finanzberatung für Ludwigshafen: Altersvorsorge, ETF, Steueroptimierung und staatliche Förderungen. Kostenlose Erstberatung – 100% digital."
    />
  );
}
